export enum EnvironmentPlatform {
    WEB = 'WEB',
    IOS = 'IOS',
    AND = 'AND',
}

export enum EnvironmentCode {
    PRO = 'PRO',
    PRE = 'PRE',
    DEV = 'DEV',
}

// The same as EnvironmentCode but in lowercase to match datadogs syntax for tags
export enum DatadogEnvironmentCode {
    PRO = 'pro',
    PRE = 'pre',
    DEV = 'dev',
}

export interface EnvironmentTemplate {
    isDevelopment: boolean;
    // Default credentials to use in login, only set in dev mode.
    DEFAULT_EMAIL: string;
    DEFAULT_PASSWORD: string;

    ENVIRONMENT_CODE: EnvironmentCode;
    DATADOG_ENVIRONMENT_CODE: DatadogEnvironmentCode;
    API_BASE_URL: string;
    ADYEN_CLIENT_CODE: string,
    ADYEN_ENVIRONMENT: 'test' | 'live',
    // The hostname where the web application will be served.
    HOSTNAME: string;
    // The protocol used to serve the web application.
    PROTOCOL: string;
    // The port on which the web application will be served.
    PORT: string,
    //Google Tag Manager.
    GTM_ID: string,
    SITE_NAME: string,
    // The name of the brand used in the title of the tab.
    BRAND_NAME: string,
    // The base URL where the web application will be served. It is composed of the protocol, hostname, and port.
    BASE_URL: string,
    // The platform on which the application is running.
    PLATFORM: EnvironmentPlatform,
    // The version of the application, following semantic versioning.
    PROJECT_VERSION: string,
    // The version of the local storage schemas.
    // It is an integer that is incremented every time the format of the data stored in local storage changes.
    DB_VERSION: number,
    SENTRY_DSN: string,
    RECAPTCHA_SITE_KEY: string,
    // Sent in all requests to SAPI to indicate whether SAPI or ALMA should be used.
    SITE: string,
    APP_STORE_LINK: string,
    GOOGLE_PLAY_LINK: string,
    // This is the link that will be shared when the user clicks on "Recommend our app".
    // It will be used to redirect the user to the app or to store or to the web app if the app is not installed.
    OPEN_APP_LINK: string,
    // If the functionality of generating a catalog in PDF is enabled
    IS_PDF_CATALOG_ENABLED: boolean,
    APPLE_PAY_MERCHANT_IDENTIFIER: string,
    // This is the API key required to use Firebase on the web.
    // It is used for creating dynamic links.
    FIREBASE_WEB_APY_KEY: string,
  }
